import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Navbar from './Navbar'
import TrocarSenhaObrigatoria from './TrocarSenhaObrigatoria'

export default function Layout() {
  const { usuario, loading } = useAuth()
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>Carregando...</div>
  if (!usuario) return <Navigate to="/login" />
  if (usuario.senha_temporaria) return <TrocarSenhaObrigatoria />
  return (
    <div className="layout-top">
      <Navbar />
      <div className="main-top">
        <Outlet />
      </div>
    </div>
  )
}
